// Returns the width and height in pixels of some text using a given font.
// To do this, the text is added to the html body with 'visibility: hidden' and is measured.
// Rounded to the nearest integer
export const getTextWidthAndHeight = (
  text: string,
  fontFamily: string,
  fontPx: number,
  fontWeight: number = 500,
  letterSpacingPx: number = 0,
) => {
  const textElement = document.createElement("span")
  textElement.style.fontFamily = fontFamily
  textElement.style.fontSize = `${fontPx}px`
  textElement.style.fontWeight = `${fontWeight}`
  textElement.style.visibility = "hidden"
  textElement.style.position = "absolute"
  textElement.style.letterSpacing = `${letterSpacingPx}px`
  textElement.style.whiteSpace = "nowrap"
  textElement.textContent = text

  document.querySelector("body").append(textElement)
  const width = textElement.clientWidth
  const height = textElement.clientHeight
  textElement.remove()

  return { width, height }
}
